import { render, staticRenderFns } from "./ReleasesList.vue?vue&type=template&id=c1a3a16e"
import script from "./ReleasesList.vue?vue&type=script&lang=js"
export * from "./ReleasesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports